exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".test-tinymce-editor {\n  width: 100%;\n}\n.test-tinymce-editor .tox.tox-tinymce {\n  border-radius: 6px;\n}\n.test-tinymce-editor .tox .tox-toolbar__group {\n  border-right-color: #000;\n  margin-top: 1.5px;\n}\n.test-tinymce-editor .tox .tox-tbtn {\n  width: 30px;\n  height: 30px;\n}\n.test-tinymce-editor .tox .tox-split-button__chevron {\n  width: 16px;\n}", ""]);

// exports
